import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { UserService } from 'src/app/service/user-info/user.service'
import { DdcButtonNTwoComponent } from 'src/app/shared/ddc/ddc-button-n-two/ddc-button-n-two.component'
import { DdcLoadingSkeletonComponent } from '../../shared/ddc/ddc-loading-skeleton/ddc-loading-skeleton.component'

@Component({
  selector: 'ddc-setting-billing-and-plans',
  templateUrl: './ddc-setting-billing-and-plans.component.html',
  styleUrl: './ddc-setting-billing-and-plans.component.scss',
  imports: [DdcLoadingSkeletonComponent, DdcButtonNTwoComponent],
})
export class DdcSettingBillingAndPlansComponent implements OnInit {
  _info: any

  constructor(
    private logger: DdcLoggerService,
    private router: Router,
    public user_service: UserService,
  ) {}

  ngOnInit(): void {
    this.getBillsInfo()
  }

  getBillsInfo(): void {
    this.logger.info('DdcDashboardCardComponent: getDashboardInfo()')
    this.user_service.get_user_profile().subscribe((res: any) => {
      if (res) {
        setTimeout(() => {
          this._info = res
        }, 500) // two seconds
      }
    })
  }
}
